import 'react';
import PropTypes from 'prop-types';
import styled from '@happymoneyinc/styled-components';
import { jsx } from 'react/jsx-runtime';

const FadeInAndOut = props => {
  const {
    children,
    visible,
    transition
  } = props;
  return /*#__PURE__*/jsx(FadeInAndOutBase, {
    transition: transition,
    visible: visible,
    children: children
  });
};
const FadeInAndOutBase = styled.div`
  ${_ref => {
  let {
    transition
  } = _ref;
  return transition;
}}

  display: block;
  max-height: 100%;
  transform: translate3d(0, 0, 0);
  opacity: 1;

  ${_ref2 => {
  let {
    visible
  } = _ref2;
  return !visible && `
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    transform: translate3d(0, -20px, 0);
  `;
}}
`;
FadeInAndOut.defaultProps = {
  transition: 'transition: all 300ms cubic-bezier(0.215, 0.61, 0.355, 1);',
  visible: true
};
FadeInAndOut.propTypes = {
  children: PropTypes.node.isRequired,
  transition: PropTypes.string,
  visible: PropTypes.bool
};
var FadeInAndOut$1 = FadeInAndOut;

export { FadeInAndOut$1 as default };
//# sourceMappingURL=FadeInAndOut.js.map
